import { ReactElement, useState } from 'react';
import MenuButton from './menuButton';
import { MenuVariationI } from '.';
import { HeaderRow, MenuMobileContainer, StyledCloseMark } from './styles';
import {
  ListIcon,
  LogoutIcon,
  MainLogo,
  RefreshIcon,
} from '@root/src/assets/images';
import Lang from '@lang/en';
import { MenuDangerOption, MenuOption } from './menuMobileOptions';

const MenuMobile = ({
  handleLogout,
  handleGoToDashboard: handleGoToDashboardPartial,
  refreshOTP,
}: MenuVariationI): ReactElement => {
  const [showMenu, setShowMenu] = useState(false);

  const handleMenuClick = () => {
    setShowMenu(true);
  };

  const handleCloseClick = () => {
    setShowMenu(false);
  };

  const handleGoToDashboard = () => {
    handleCloseClick();
    handleGoToDashboardPartial();
  };

  return !showMenu ? (
    <MenuButton
      data-testid="healthcheck-navbar-menu-icon"
      onClick={handleMenuClick}
    />
  ) : (
    <MenuMobileContainer>
      <HeaderRow>
        <MainLogo />
        <StyledCloseMark onClick={handleCloseClick} />
      </HeaderRow>
      <MenuOption
        data-testid="healthcheck-navbar-menu-orders"
        icon={<ListIcon />}
        noStroke
        onClick={handleGoToDashboard}
        label={Lang.healthCheckMenuOrdersOption}
      />
      <MenuOption
        data-testid="healthcheck-navbar-menu-refreshOtp"
        icon={<RefreshIcon />}
        noFill
        onClick={refreshOTP}
        label={Lang.healthCheckMenuRefreshOTPOption}
      />
      <MenuDangerOption
        data-testid="healthcheck-navbar-menu-logout"
        icon={<LogoutIcon />}
        onClick={handleLogout}
        label={Lang.healthCheckMenuLogoutOption}
      />
    </MenuMobileContainer>
  );
};

export default MenuMobile;
